exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-badge[data-v-26a6cde2]{font-size:9px;font-weight:500;text-transform:uppercase;padding:6px 9px 5px;border-radius:3px;margin-top:1px;font-family:Fira Sans,sans-serif;font-weight:400}.sub-badge.free[data-v-26a6cde2]{color:#1e73bd;background-color:#fff;border:1px solid #1e73bd}.sub-badge.professional[data-v-26a6cde2]{color:#fff;background-color:#1e73bd;border:1px solid #1e73bd}.sub-badge.team[data-v-26a6cde2]{color:#fff;background-color:#23a6cd;border:1px solid #23a6cd}.sub-badge.enterprise[data-v-26a6cde2]{color:#fff;background-color:#ba8c00;border:1px solid #ba8c00}", ""]);

// exports
